<template>
    <Head title="Welcome to Pitch" />

    <BreezeValidationErrors class="mb-4" />

    <form @submit.prevent="submit">
        <BreezeInput id="password" type="hidden" class="mt-1 block w-full" v-model="form.email" required autocomplete="new-password" />

        <div class="mt-4">
            <BreezeLabel for="password" value="Password" />
            <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
        </div>

        <div class="mt-4">
            <BreezeLabel for="password_confirmation" value="Confirm Password" />
            <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
        </div>

        <div class="flex items-center justify-end mt-4">
            <BreezeButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save Password & Login
            </BreezeButton>
        </div>
    </form>
</template>

<script>
import BreezeButton from '@/Components/Button.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Input.vue'
import BreezeLabel from '@/Components/Label.vue'
import BreezeValidationErrors from '@/Components/ValidationErrors.vue'
import {Head, usePage} from '@inertiajs/vue3';
import { computed} from "vue";

export default {
    layout: BreezeGuestLayout,

    components: {
        BreezeButton,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
        Head,
    },

    props: {
        email: String,
        user: Object,
        signature: String
    },

    data() {
        return {
            form: this.$inertia.form({
                email: this.user.email,
                password: '',
                password_confirmation: ''
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('welcome.submit', this.user.id) + '?signature=' + this.signature, {
                onFinish: () => this.form.reset('password', 'password_confirmation'),
            })
        }
    }
}
</script>
